import { useEffect } from 'react'

let lockCount = 0
let previousOverflow = ''
let previousPadding = ''

const lock = () => {
    if (lockCount === 0) {
        const scrollbar = window.innerWidth - document.documentElement.clientWidth

        previousOverflow = document.body.style.overflow
        previousPadding = document.body.style.paddingRight
        document.body.style.overflow = 'hidden'

        if (scrollbar > 0) document.body.style.paddingRight = `${scrollbar}px`
    }

    lockCount += 1
}

const unlock = () => {
    lockCount = Math.max(0, lockCount - 1)

    if (lockCount === 0) {
        document.body.style.overflow = previousOverflow
        document.body.style.paddingRight = previousPadding
    }
}

// Locks page scrolling while `active` is true. Nested locks are counted.
export const useScrollLock = (active: boolean) => {
    useEffect(() => {
        if (!active) return

        lock()

        return unlock
    }, [active])
}
